<template>
    <div class="console-body-content-item console-video-runtime">
        <div class="console-body-content-item-title">
            <span>Runtime Monitor</span>
        </div>
        <div class="console-body-line">
            <span class="fw-bold">Current Time by Player: </span><span class="console-body-text">{{ getCurrentTimePlayer }}</span>
        </div>
        <div class="console-body-line">
            <span class="fw-bold">Current Time Calculated: </span><span class="console-body-text">{{ getVideoMetrics.currentTimeFormatted }}</span>
        </div>
        <div class="console-body-line">
            <span class="fw-bold">Current Time by Seconds: </span><span class="console-body-text">{{ getCurrentTimeCalculatedBySeconds }}</span>
        </div>
        <div class="console-body-line">
            <span class="fw-bold">Current Frame by Time: </span><span class="console-body-text">{{ getVideoMetrics.currentFrameInASecondByTime }}</span>
        </div>
        <div class="console-body-line">
            <span class="fw-bold">Time Executed: </span><span class="console-body-text">{{ getVideoMetrics.realTimeExecutedFormatted }}</span>
        </div>
        <div class="console-body-line">
            <span class="fw-bold">Current Frame in a Second by Time Executed: </span><span class="console-body-text">{{ getVideoMetrics.currentFrameInASecondByTimeExecuted }}</span>
        </div>
        <div class="console-body-line">
            <span class="fw-bold">Executed Frames by Time Executed: </span><span class="console-body-text">{{ getVideoMetrics.framesByTimeExecutedFormatted }}</span>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import { addCeroToNumber, timeFormat } from "@/playerVue3/services/misc-service";

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS & EMITS
const props = defineProps({
    currentTimePlayer: {
        type: Number,
        default: 0,
    },
});

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const getCurrentTimePlayer = computed(() => {
    return timeFormat(props.currentTimePlayer);
});

const getCurrentTimeCalculatedBySeconds = computed(() => {
    const seconds = getVideoMetrics.value.currentTimeBySeconds;
    const ss = Math.floor(seconds);
    const ms = ~~((seconds - ~~seconds) * 1000);
    return `${addCeroToNumber(ss)}:${addCeroToNumber(ms, 3)}`;
});

const getVideoMetrics = computed(() => {
    return store.getPlayerMetrics;
});

// METHODS

// LIFECYCLE HOOKS
</script>
